module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    staticClass: "popup-user-reset-password",
    attrs: {
      "id": _vm.nameId,
      "opened": _vm.popupOpened
    },
    on: {
      "popup:opened": function($event) {
        _vm.popupOpened = true
      },
      "popup:closed": function($event) {
        _vm.popupOpened = false
      }
    }
  }, [_c('div', {
    staticClass: "container-user-reset-password"
  }, [_c('br'), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.$t('common.idtfr'),
      "placeholderValue": _vm.$t('common.idtfr'),
      "inputType": "text"
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('administration.reset_password')))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ca55217", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ca55217","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/user/CMUserResetPassword.vue
// module id = 2372
// module chunks = 2